// Copyright (c) 2023 Ryan Piaskowy. All Rights Reserved.

const config = {
    regionsTsvUrl: 'https://storage.googleapis.com/mixit-city-data/export/regions/regions-000000000000.tsv',
    regionSubmissionFormUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdXcbYpWTG6hMtt-6W-h6UCdTVbDdErBspST-JWvijzTmWVbw/viewform?usp=pp_url&entry.957082191=',
    updateEventFormUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSc2hSbV9M7QYpHTymZ2BbquD-4nc_t640v-LNsYCTcG0DNp8Q/viewform?usp=pp_url&entry.840849926=',
    // Temporary kill switches for features whose underlying data isn't
    // populated yet. Flip to `true` (no other code changes needed) once
    // the Neighborhood column / is_duplicate TSV column are ready.
    featureFlags: {
      showNeighborhoodFilter: false,
      showDuplicatesFilter: false,
    },
  };
  
  export default config;
